import { useSelfQuery, useUpdatePatientProfileMutation } from "@/data/queries"
import { toPatientAppStateApiDto } from "@/model/PatientAppState"
import type { Self } from "@/model/Self"
import { ROUTES } from "@/routes"
import { useNavigate } from "react-router"

export const afterOnboardingRouteFor = (self: Self): string =>
  self.patientAppState.bloodGlucoseDeviceSetupCompleted
    ? ROUTES.DASHBOARD
    : ROUTES.BLOOD_GLUCOSE_DEVICE_SETUP

export const useFinishOnboarding = () => {
  const navigate = useNavigate()
  const { data: self } = useSelfQuery()
  const { mutateAsync: updateProfile, isPending } = useUpdatePatientProfileMutation()

  const finishOnboarding = async () => {
    if (!self) return
    if (!self.patientAppState.profileFormFilled) {
      await updateProfile({
        patientId: self.id,
        profile: {
          patientAppState: toPatientAppStateApiDto({
            ...self.patientAppState,
            profileFormFilled: true,
          }),
        },
      })
    }
    const route = afterOnboardingRouteFor(self)
    navigate(route, route === ROUTES.DASHBOARD ? { state: { initialLogin: true } } : undefined)
  }

  return { finishOnboarding, isPending }
}
